import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductsQuizzes } from '@/features/quizzes'

export const Route = createFileRoute('/_event/quizzes/')({
  component: DigitalProductsQuizzesPage
})

function DigitalProductsQuizzesPage() {
  return <DigitalProductsQuizzes />
}
